<template>
  <div
    class="mx-3 my-2"
  >
    <div
      class="inline-flex cursor-default items-center w-full pl-3"
    >
      <div class="inline-flex flex-col">
        <span class="grey-text-title text-xs">
          Workspace
        </span>
        <span class="font-bold team-name">
          {{ getWorkspaceTitle }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import constants from '@/constant'

export default {
  components: {

  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      currentAccount: (state) => state.currentAccount,
      currentUser: (state) => state.currentUser,
      workingMode: (state) => state.workingMode,
    }),
    isTeamActive() {
      if (this.$route.name === 'Team') return true
      return false
    },
    getWorkspaceTitle() {
      if (this.workingMode === constants.workspace.PERSONAL) return 'Personal'
      return this.currentAccount.name
    },
  },
  methods: {
    ...mapActions([
      'setCurrentAccountAction',
    ]),
    getTeamTotalMember(account) {
      if (account.totalMembers) {
        if (account.totalMembers == 1) return `${account.totalMembers} member`
        return `${account.totalMembers} members`
      }
      return ''
    },
    switchToPersonalWorkspace() {
      this.$store.state.workingMode = constants.workspace.PERSONAL
      this.$router.push({ name: 'Presentations' })
    },
    switchToTeamWorkspace() {
      this.$store.state.workingMode = constants.workspace.TEAM
      this.$router.push({ name: 'Team' })
    },
  },
}
</script>
<style scoped lang="scss">
.grey-text-title {
  color: rgba(255,255,255, 0.65);
}
.team-name {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 9rem;
  white-space: nowrap;
  font-size: 16px;
  @apply mt-0.5;
}

</style>
